import * as React from 'react'

function LogoGuardian(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='100%'
      fill='none'
      viewBox='0 0 992 440'
      {...props}
    >
      <path
        fill='#1d2a60'
        d='M191.8,223.4c0-36.2,27-65.7,66.5-65.7s44.3,12,54.7,27.1c.9,1.3.6,3.1-.6,4.1l-14.8,11.6c-1.3,1.1-3.3.8-4.3-.6-7-9.6-17.2-15.9-31.5-15.9-20.5,0-37.5,17.2-37.5,39s16.7,39.2,38,39.2,23.7-6.5,30.2-15.2c1-1.4,3-1.6,4.3-.5l15.1,12.4c1.2,1,1.5,2.9.5,4.1-10,13-28.6,25.9-54,25.9-39,0-66.5-29.5-66.5-65.5Z'
      />
      <path
        fill='#1d2a60'
        d='M313.7,223.4c0-36.7,28.5-65.2,62.7-65.2s28.2,5.1,37.7,13.6c1.9,1.7,5,.4,5-2.2v-5.9c0-1.7,1.3-3,3-3h26.5c1.7,0,3,1.3,3,3v119c0,1.7-1.3,3-3,3h-26.5c-1.7,0-3-1.3-3-3v-6.3c0-2.6-3.1-4-5-2.2-9.6,8.7-22.2,14-37.2,14-34.2,0-63.2-28-63.2-64.7ZM345.4,223.4c0,20.7,15.5,39,36.7,39s37-18.5,37-39-15.7-39.2-37-39.2-36.7,18.5-36.7,39.2Z'
      />
      <path
        fill='#1d2a60'
        d='M494.4,163.6v6c0,2.6,3.1,4,5,2.2,9.5-8.6,22.4-13.7,38-13.7,34.2,0,62.5,28.5,62.5,65.2s-29,64.7-63.2,64.7-27.8-5.3-37.2-13.9c-1.9-1.8-5.1-.4-5.1,2.2v56.2c0,1.7-1.3,3-3,3h-26.5c-1.7,0-3-1.3-3-3v-169c0-1.7,1.3-3,3-3h26.5c1.7,0,3,1.3,3,3ZM531.4,262.3c21.2,0,37-18.5,37-39s-15.7-39.2-37-39.2-36.7,18.5-37,39.2c0,20.7,15.7,39,37,39Z'
      />
      <path
        fill='#1d2a60'
        d='M609.7,160.6c1.7,0,3-1.3,3-3v-7.7c0-27.7,14-42.2,40.5-42.2s18,2.2,25.6,4.4c1.6.5,2.5,2.1,2,3.7l-4.8,16.2c-.5,1.5-2,2.4-3.6,2.1-4.8-1.1-8.9-1.8-12.2-1.8-10.7.2-15,5.5-15,20v5.5c0,1.7,1.3,3,3,3h25.1c1.3,0,2.4,1.1,2.4,2.4v21.1c0,1.3-1.1,2.4-2.4,2.4h-25.1c-1.7,0-3,1.3-3,3v93c0,1.7-1.3,3-3,3h-26.5c-1.7,0-3-1.3-3-3v-93c0-1.7-1.3-3-3-3h-7.1c-1.3,0-2.4-1.1-2.4-2.4v-21.1c0-1.3,1.1-2.4,2.4-2.4h7.1Z'
      />
      <path
        fill='#1d2a60'
        d='M748.5,186.1s5.9-8.8,16.3-24.2c.9-1.4,2.2-1.4,4.8-1.3,0,0,20.9,0,28.5,0s1.9,3,1,4.4c-13.7,20.1-29.7,44.1-29.7,44.1-1,1.4-2.5,4.1-3.8,2.1-4.3-6.3-17-25.1-17-25.1Z'
      />
      <path
        fill='#4de4e5'
        d='M759.1,219.2c-1.4-2.1-3.1-4.7-5.1-7.6-10.3-15.3-24.7-36.6-33.6-49.8-.9-1.4-2.2-1.4-4.8-1.3,0,0-20.8,0-28.4,0-1.7,0-2.3,2.9-1.4,4.3,8.2,12,25.7,38,38.5,57l-40.3,59.8c-1.8,2.7-.7,4.5,1,4.5h28.7c1.7,0,3.4.3,4.4-1.1,10.3-14.9,30.6-45.1,40.8-60.3,1.6-2.4,1.6-3.3.2-5.4Z'
      />
    </svg>
  )
}

export default LogoGuardian
